import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut as firebaseSignOut } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCMMdz_5Wq-Aka8USedVOqf5JOeCIa1Xvw",
    authDomain: "generative-viewmaster.firebaseapp.com",
    projectId: "generative-viewmaster",
    storageBucket: "generative-viewmaster.appspot.com",
    messagingSenderId: "210961266812",
    appId: "1:210961266812:web:c2c2a5dd750cd5c31ff1f9",
    measurementId: "G-QG8JRWGSCW"
};

const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth(firebaseApp);

export const signIn = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            // Signed in 
            const user = userCredential.user;
            console.log("signed in!");
            return user;
            // ...
        })
        .catch((error) => {
            console.error(error);
            return error;
        });

}

export const signOut = async () => {
    await firebaseSignOut(auth);
};


export const ProtectedRoute = ({ isAuthenticated, redirect, outlet }) => {
    if (isAuthenticated) {
        return outlet;
    } else {
        return redirect;
    }
};